export interface IPrecheckinSharedStateModel {
  hasRequestError: boolean;
  hasTriedToSave: boolean;
}

export const defaultSharedState = {
  hasRequestError: false,
  hasTriedToSave: false
} as IPrecheckinSharedStateModel;
